<template>
  <InfoIcon :name="tipKey" class="w-3 h-3 ml-2 mr-2 cursor-pointer" />
  <TippyContent :options="tippyOptions" :to="tipKey">
    <span v-if="specialCategoryMessage.length">{{
      specialCategoryMessage
    }}</span>
    <ServiceabilityChangeTimeline
      v-if="Object.keys(timeline).length"
      :add-category="addCategory"
      :category="history?.category ?? ''"
      :data="timeline"
    />
    <template v-if="!singleView">
      <!--      <MemoContent description="Description too long. Kindly click the icon." />-->
      <span
        class="cursor-pointer p-2 text-blue-600"
        @click="handleLongDescription"
        >Description too long. Click to<Maximize2Icon
          class="w-3 h-3 ml-2 mr-2 cursor-pointer underline"
      /></span>
    </template>
    <MemoContent v-else :description="description" />
  </TippyContent>
</template>
<script>
import { defineComponent, computed, ref } from "vue";
import { useStore } from "@/store";
import MemoContent from "@/components/loan-application-details/audit-logs/MemoContent";
import ServiceabilityChangeTimeline from "../common/ServiceabilityChangeTimeline.vue";

export default defineComponent({
  components: { MemoContent, ServiceabilityChangeTimeline },
  props: {
    categoryKey: {
      type: String,
      required: false,
      default: ""
    },
    tipKey: {
      type: String,
      required: true
    },
    history: {
      type: Object,
      required: false,
      default: _ => ({
        timeline: {},
        category: ""
      })
    },
    description: {
      type: String,
      required: true,
      default: ""
    },
    addCategory: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const store = useStore();
    //Conversion
    const tippyOptions = {
      trigger: "mouseenter"
    };

    const kycWithAdditionalAttributes = computed(
      () => store.state.loanAssessmentInfos.kycWithAdditionalAttributes
    );

    const specialMessagesAccordingtoCategory = ref({});

    function updateSpecialMessages(category) {
      if (category === "discretionary") {
        let recreationalExpensesAttr =
          kycWithAdditionalAttributes.value.basicAttributes?.additional_attributes.find(
            val =>
              val.attr === "Are_you_willing_to_lower_recreational_spending_o"
          )?.value ?? "";

        specialMessagesAccordingtoCategory.value["discretionary"] =
          "Are you willing to lower recreational spending? " +
            recreationalExpensesAttr ?? "";
      }
    }

    const specialCategoryMessage = computed(() => {
      updateSpecialMessages(props.categoryKey);
      return specialMessagesAccordingtoCategory.value[props.categoryKey] ?? "";
    });

    const handleLongDescription = () => {
      store.commit("memos/setHistory", props.history);
      store.commit("memos/setMemos", props.description);
      cash("#history-memo-detail-view").modal("show");
    };

    const singleView = computed(() => {
      let timeline = Object.keys(props.history?.timeline ?? {});
      let description = props.description ?? "";
      return (
        (timeline.length && !description.length) ||
        (!timeline.length && description.length < 400)
      );
    });

    const timeline = props.history?.timeline ?? {};

    return {
      tippyOptions,
      singleView,
      timeline,
      specialCategoryMessage,
      handleLongDescription
    };
  }
});
</script>
<style scoped />
